/* eslint-disable */
export abstract class BaseLogger {
  abstract info(data: object, msg?: string): void;
  abstract error(data: object, msg?: string): void;
  abstract warn(data: object, msg?: string): void;
}

export class NoOpLogger extends BaseLogger {
  info() {}
  error() {}
  warn() {}
}
